import React from 'react';
import NotificationStats from './NotificationStats';
import NotificationFilters from './NotificationFilters';
import NotificationList from './NotificationList';

const NotificationTabContent = ({ 
  statistics, 
  filters, 
  onFilterChange, 
  notifications, 
  loading, 
  onView, 
  onEdit, 
  onSend, 
  onDelete,
  pagination,
  onPageChange
}) => {
  return (
    <>
      {/* Statistiques */}
      {statistics && <NotificationStats statistics={statistics} />}

      {/* Filtres */}
      <NotificationFilters
        filters={filters}
        onFilterChange={onFilterChange}
      />

      {/* Liste des notifications avec pagination */}
      <NotificationList
        notifications={notifications}
        loading={loading}
        onView={onView}
        onEdit={onEdit}
        onSend={onSend}
        onDelete={onDelete}
        pagination={pagination}
        onPageChange={onPageChange}
      />
    </>
  );
};

export default NotificationTabContent;